import { DEFAULT_ID } from "@usas/ui-web/utils/Constants";
import { NO_DATA_MESSAGE, PersonHttpHelper } from "@usas/ui-web/utils/HttpHelper";
import { isValidMemberId } from "@usas/ui-web/utils/validation";

export const localValidate = (formState) => {
  let errors = {};

  // Member Id
  if (formState.memberId.trim().length === 0) {
    errors.memberId = 'Staff Member Id is required';
  } else if (isValidMemberId(formState.memberId.trim()) === false) {
    errors.memberId = 'Staff Member Id must be 14 alphanumeric characters';
  }

  // Staff Role
  if (formState.personOrgRole.length === 0) {
    errors.personOrgRole = 'Must select at least one staff role';
  }

  // Full/Part Time
  if (formState.hasCoachRole === true) {
    if (formState.coachTypeCode === DEFAULT_ID || formState.coachTypeCode === '') {
      errors.coachTypeCode = 'Must make a selection';
    }
  }

  return errors;
};

export const serverValidate = async (formState) => {
  let errors = {};

  const memberIdForUrl = formState.memberId ? encodeURIComponent(formState.memberId) : 'NaN';
  const roleGroupIdForUrl = formState.registrationRoleGroupId ? encodeURI(formState.registrationRoleGroupId) : 'NaN';
  await PersonHttpHelper(`/Person/member/${memberIdForUrl}/hasActiveRegistration?roleGroupId=${roleGroupIdForUrl}`, 'GET')
    .then((objData) => {
      if (!objData) {
        throw new Error(NO_DATA_MESSAGE);
      } else {
        if (formState.hasCoachRole && objData.hasActiveCoachRegistration === false) {
          errors.errorOnSubmitAction = "This person does not have an active coach registration";
        } else if (objData.hasActiveRegistration === false) {
          errors.errorOnSubmitAction = "This person does not have an active registration";
        } else {
          formState.personId = objData.personId;
        }
      }
    })
    .catch(() => {
      errors.errorOnSubmitAction = "This person does not have an active registration";
    });

  return errors;
};

const ClubStaffAddFormValidation = async (formState) => {
  let errors = localValidate(formState);

  //server validate only done if local validate succeeds and is not an edit
  if ((!errors || Object.keys(errors).length === 0)) {
    errors = await serverValidate(formState);
  }

  return errors ? errors : {};
}

export default ClubStaffAddFormValidation;